<template>
    <div class="form">
        <h4 class="step-title">
            What is your gender?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <button-list v-bind:items="genders" v-bind:onclick="complete"></button-list>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "Gender",
        components: {
            ButtonList
        },
        data: function() {
            return {
                genders: [
                    { text: "Male", value: "Male" },
                    { text: "Female", value: "Female" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(gender) {
                this.lead.gender = gender;
                this.$emit("complete", this.$options.name, gender);
            }
        }
    }
</script>
